/**
 * Qué muestra el visor de una solicitud de eliminación (spec
 * 2026-09-28-grupos-supervisoras §7.1): el archivo que se eliminará y, si es
 * un adjunto, el documento al que pertenece, que se conserva.
 *
 * El enlace sale del archivo VIVO (files/{id}); el `itemUrl` guardado en la
 * solicitud solo es respaldo si el archivo ya no existe. Todo enlace pasa por
 * isSafeStorageUrl: la solicitud la escribe quien pide y la abre una
 * supervisora. Módulo puro.
 */

import { isSafeStorageUrl, KIND_LABELS } from './deletion_request';

export const fileKind = (data) => {
  const type = String(data?.type || '').toLowerCase();
  const name = String(data?.name || '').toLowerCase();
  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (type.includes('xml') || name.endsWith('.xml')) return 'xml';
  return 'other';
};

const pane = ({ role, label, data, fallbackUrl, fallbackName, reason }) => {
  const name = data?.name || fallbackName || '';
  let url = null;
  if (data && isSafeStorageUrl(data.url)) url = data.url;
  else if (!data && isSafeStorageUrl(fallbackUrl)) url = fallbackUrl;
  return {
    role, label, name, url,
    kind: url ? fileKind(data || { name }) : 'missing',
    ...(reason ? { reason } : {}),
  };
};

export const previewPanes = (request, parentData, itemData) => {
  if (!request) return [];
  const itemName = itemData?.name || request.itemName || '';
  const del = pane({
    role: 'delete',
    label: request.kind === 'document'
      ? `Se eliminará el documento completo: ${itemName}`
      : `Se eliminará: ${KIND_LABELS[request.kind] || 'Archivo'} — ${itemName}`,
    data: itemData, fallbackUrl: request.itemUrl, fallbackName: request.itemName, reason: request.reason,
  });
  if (request.kind === 'document') return [del];
  const parentName = parentData?.name || request.parentName || '';
  return [del, pane({
    role: 'keep', label: `Documento — se conserva: ${parentName}`,
    data: parentData, fallbackUrl: null, fallbackName: request.parentName,
  })];
};

/** Sangría de 2 espacios por nivel. Lo que no empieza por '<' se devuelve igual. */
export const formatXml = (text) => {
  const src = String(text ?? '').trim();
  if (!src.startsWith('<')) return src;
  const tokens = src.replace(/>\s*</g, '><').split(/(?=<)|(?<=>)/).filter((t) => t.trim() !== '');
  const lines = [];
  let depth = 0;
  for (let i = 0; i < tokens.length; i += 1) {
    const t = tokens[i];
    if (/^<\//.test(t)) {
      depth = Math.max(0, depth - 1);
      lines.push(`${'  '.repeat(depth)}${t}`);
    } else if (/^<[^!?][^>]*[^/]>$|^<[^!?/>]>$/.test(t) && tokens[i + 1] && !tokens[i + 1].startsWith('<') && /^<\//.test(tokens[i + 2] || '')) {
      // <b>texto</b> en una sola línea.
      lines.push(`${'  '.repeat(depth)}${t}${tokens[i + 1]}${tokens[i + 2]}`);
      i += 2;
    } else if (/^<[^!?][^>]*[^/]>$|^<[^!?/>]>$/.test(t)) {
      lines.push(`${'  '.repeat(depth)}${t}`);
      depth += 1;
    } else {
      lines.push(`${'  '.repeat(depth)}${t}`);
    }
  }
  return lines.join('\n');
};
